"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageSelectionDialog = void 0;
const vue_1 = require("vue");
const constants_1 = require("../constants");
const PreferencesManager_1 = require("./PreferencesManager");
exports.LanguageSelectionDialog = vue_1.default.component('language-selection-dialog', {
    name: 'LanguageSelectionDialog',
    props: {
        preferencesManager: {
            type: Object,
        },
    },
    methods: {
        switchLanguageTo(langId) {
            PreferencesManager_1.PreferencesManager.save('lang', langId);
            window.location.reload();
        },
    },
    computed: {
        LANGUAGES() {
            return constants_1.LANGUAGES;
        },
    },
    template: `
<div class="preferences_panel">
    <div class="preferences_panel_item form-group">
      <div class="preferences_panel_langs">
        <label class="form-radio" v-for="lang in LANGUAGES" :key="lang.id">
          <div
            :key="lang.id"
            :class="'language-icon language-icon--' + lang.id"
            :title="lang.title"
            @click="switchLanguageTo(lang.id)"
            style="vertical-align:sub;"
          />
          {{ lang.title }}
        </label>
      </div>
    </div>
  </div>
  `,
});
//# sourceMappingURL=LanguageSelectionDialog.js.map